import type { MessageKey } from './pt.js';

/** Ajustes de português do Brasil sobre o texto neutro. */
export const ptBR: Partial<Record<MessageKey, string>> = {
  'create.nickname': 'Seu apelido',
  'join.nickname': 'Seu apelido',
  'create.nicknamePlaceholder': 'Como você quer ser chamado?',
  'lobby.share': 'Compartilhar',
  'lobby.copy': 'Copiar link',
  'howto.install':
    'Abra o menu do navegador e escolha "Adicionar à tela de início" para jogar em tela cheia.',
};
